// extracted by mini-css-extract-plugin
module.exports = {"not-logged-in":"_1aBlW","notLoggedIn":"_1aBlW","languages-button":"_30xaR","languagesButton":"_30xaR","login-button":"_2Hgsm","loginButton":"_2Hgsm"};